import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { LanguageService } from '@core/language/language.service';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { filter, map, switchMap, switchMapTo } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { logPageStasticsTypes } from '@core/log-page-stastics-type';
import { HttpService } from '@core/http/http.service';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(
    private languageService: LanguageService, private router: Router,
    private changeDetectorRef: ChangeDetectorRef, private activatedRoute: ActivatedRoute,
    private httpService: HttpService) { }

  title = 'cbc-app';
  isLangSetted = false;

  private currentStyleLang: string;

  ngOnInit(): void {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const urlSplit = e.urlAfterRedirects.split('/');
        const lang = urlSplit[1];

        // set css
        this.setStyleCss(lang);

        // set lang
        if (!this.isLangSetted) {

          this.languageService.setInitState(lang).subscribe(() => {
            this.isLangSetted = true;
            this.changeDetectorRef.detectChanges();
            this.initPage();
          });
        } else {
          if (!this.languageService.isSupportLang(lang)) {
            this.router.navigate(['/', this.languageService.getLang()]);
          } else if (this.languageService.getLang() !== lang) {
            this.languageService.setLang(lang).subscribe(() => {
              this.router.navigate([`/${this.languageService.getLang()}`]);
            });
          }
        }

        // scroll to top
        window.scrollTo(0, 0);

        // log page stastics
        this.logPageStastics(e.urlAfterRedirects);
      });
  }

  private logPageStastics(url: string): void {
    const urlSplit = url.split('/');
    // non-route
    if (urlSplit.length < 2) {
      return;
    }

    let type: string;
    let subType: string;
    // Index Page
    if (urlSplit.length == 2) {
      const lang = urlSplit[1];
      if (lang === 'zh-tw') {
        type = "大眾版-首頁";
      }
      else if (lang === 'en-us') {
        type = "英文版-首頁";
      }
      else {
        return;
      }
    }
    else {
      const module = urlSplit[2];
      const page = urlSplit[3];
      if (!!logPageStasticsTypes[module]) {
        type = logPageStasticsTypes[module].type;

        const subTypeKey = logPageStasticsTypes[module].subTypeKeys
          .find(s => s.keys.includes(page));
        if (!!subTypeKey) {
          subType = subTypeKey.subType;
        }
        else if (!!logPageStasticsTypes[module].fixSubType) {
          subType = logPageStasticsTypes[module].fixSubType;
        }
        else {
          return;
        }
      }
      else {
        return;
      }
    }

    this.httpService.pageStastics(type, subType, url).subscribe();
  }

  private setStyleCss(lang: string): void {
    if (!this.currentStyleLang) {
      if (lang === 'en-us') {
        $('#style-languange').attr('href', 'assets/css/style-en.min.css');
      }
      else {
        $('#style-languange').attr('href', 'assets/css/style.min.css');
      }

      this.currentStyleLang = lang;
    }
    else if (this.currentStyleLang !== lang) {
      if (lang === 'en-us') {
        $('#style-languange').attr('href', 'assets/css/style-en.min.css');
      }
      else {
        $('#style-languange').attr('href', 'assets/css/style.min.css');
      }

      this.currentStyleLang = lang;
    }
  }

  private initPage() {
    // Closes the sidebar menu
    $('.menu-toggle').click(function (e) {
      e.preventDefault();
      $('#sidebar-wrapper').toggleClass('active');
      $('.menu-toggle > .fa-bars, .menu-toggle > .fa-times').toggleClass('fa-bars fa-times');
      $(this).toggleClass('active');
    });

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
      // if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      let target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, 'easeInOutExpo');
        return false;
      }
      // }
    });

    // Closes responsive menu when a scroll trigger link is clicked
    $('#sidebar-wrapper .js-scroll-trigger').click(function () {
      $('#sidebar-wrapper').removeClass('active');
      $('.menu-toggle').removeClass('active');
      $('.menu-toggle > .fa-bars, .menu-toggle > .fa-times').toggleClass('fa-bars fa-times');
    });

    // Scroll to top button appear
    $(document).scroll(function () {
      const scrollDistance = $(this).scrollTop();
      if (scrollDistance > 100) {
        $('.scroll-to-top').fadeIn();
      } else {
        $('.scroll-to-top').fadeOut();
      }
    });

    // Collapse Navbar
    const navbarCollapse = () => {
      if ($('#mainNav').offset().top > 150) {
        $('#mainNav').addClass('navbar-shrink');
      } else {
        $('#mainNav').removeClass('navbar-shrink');
      }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);
  }

  ngAfterViewInit(): void {

  }

  get currentLang() {
    return this.languageService.getLang();
  }
}
